/** Short list for UI hints */
export const EVM_WALLET_EXAMPLES = 'MetaMask, Rabby, Phantom (Ethereum), Coinbase Wallet, Brave, OKX';

export const EVM_WALLET_INSTALL_MSG = `Install an EVM browser wallet (${EVM_WALLET_EXAMPLES}) and refresh this page.`;

export const EVM_WALLET_SIGN_MSG = `Connect an EVM wallet (${EVM_WALLET_EXAMPLES}) to sign.`;

export function evmWalletMismatchMsg(connected, linkedHint = 'your linked HL wallet') {
  const c = connected ? `${connected.slice(0, 6)}…${connected.slice(-4)}` : 'this account';
  return `Connected wallet ${c} does not match ${linkedHint}. Switch to the correct account in your wallet app and retry.`;
}
